import type { ReactNode } from 'react';

/**
 * Kridt's Empty chart (components.md, "Empty state" › "Empty chart") — spec
 * 248, review P1-7.
 *
 * A chart with no data keeps its frame: the axis floor and faint gridlines at
 * the chart's REAL height, with one line and one action in the middle. The
 * reader learns what will be drawn here and where. It replaces a grey
 * rectangle, which teaches nothing and changes height when data arrives.
 */
export function EmptyChart({
  title,
  text,
  action,
  height = 240,
  testId,
}: {
  title: string;
  text?: string;
  /** The one next step — a link or button, never a description of one. */
  action?: ReactNode;
  /** The chart's real height in px, so nothing moves when data lands. */
  height?: number;
  testId?: string;
}) {
  return (
    <div
      className="hub-empty-chart"
      style={{ ['--hub-chart-height' as string]: `${height}px` }}
      data-testid={testId}
    >
      <div className="hub-empty-chart__grid" aria-hidden="true">
        <span /><span /><span /><span />
      </div>
      <div className="hub-empty-chart__say">
        <p className="hub-empty-chart__title">{title}</p>
        {text && <p className="hub-empty-chart__text">{text}</p>}
        {action}
      </div>
    </div>
  );
}
